import { createSpotStorage } from '../../libraries/utils/spot-storage-factory';
import { setSpotId as setSpotIdInMemory } from './app-state';

var SpotStorage = createSpotStorage('SpotIM.Admin.Spot', 1);

const ROLLING_STONE_SPOTS = ['sp_Q8ozJJnS', 'sp_UfHlXOBE'];

function get(spotId) {
  return new SpotStorage(spotId);
}

function getSpotId() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      var value = window.localStorage.getItem('SpotIM.SpotID');
      return value;
    }
  } catch (e) {
    // Nothing to do
  }
}

function setSpotId(spotId) {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem('SpotIM.SpotID', spotId);
      setSpotIdInMemory(spotId);
    }
  } catch (e) {
    // Nothing to do
  }
}

const isRollingStone = spotId => ROLLING_STONE_SPOTS.includes(spotId);

export { get, setSpotId, getSpotId, isRollingStone };
